import { Injectable } from '@angular/core';
import { DataService, Query, QueryColumn, ReadDocumentModel, ReadPicklistItemsModel } from '@barthauer/abc/core/data';
import { ListDataSource } from 'libs/abc/arena/src/lib/core/models/data.model';
import { Observable, of } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import { PropertyBCEDocument, PropertyDocumentSource, PropertyModel } from '../models/proprety.model';
import { PropertyViewModel } from '../viewModels/property.viewModel';

@Injectable({
  providedIn: 'root',
})
export class PropertiesService {
  public propertyData: PropertyModel[] = [];
  public picklistItem: ListDataSource;
  private properties;
  private _propertiesVM: PropertyViewModel;
  public get propertiesVM(): PropertyViewModel {
    return this._propertiesVM;
  }
  public set propertiesVM(value: PropertyViewModel) {
    this._propertiesVM = value;
  }

  constructor(private coreDataService: DataService) {}

  public getPropertyId(propertyQuery: PropertyDocumentSource): Observable<any> {
    const queryBase = new Query();
    queryBase.Columns = new Array<QueryColumn>();
    queryBase.Columns.push(
      {
        OPath: "Properties[Designation = 'PropertyDefinitionId'].TextValue",
        Name: 'PropertyDocument',
      },
      {
        OPath: "Gemeinde.Properties[Designation = 'PropertyDefinitionId'].TextValue",
        Name: 'PropertyDocumentFallBack',
      }
    );
    const query = this.coreDataService.createSimpleQuery(
      propertyQuery.objectSpaceName,
      propertyQuery.objectType,
      propertyQuery.opath,
      queryBase.Columns
    );
    return this.coreDataService.executeReadObjectsQuery(query);
  }

  public getProperties(query?: PropertyDocumentSource) {
    if (this.properties) {
      return of(this.properties);
    } else {
      if (query) {
        return this.getPropertyId(query).pipe(
          concatMap((ids) => {
            return this.prepareRequestProperties(ids);
          })
        );
      } else {
        return of({});
      }
    }
  }

  public prepareRequestProperties(ids?): Observable<any> {
    const propertyDocument = new PropertyBCEDocument(ids[0]);
    const query: ReadDocumentModel = new ReadDocumentModel();
    query.Id = propertyDocument.PropertyDocument || propertyDocument.PropertyDocumentFallBack;
    return this.coreDataService.executeReadDocumentQuery(query).pipe(
      tap((properties) => {
        this.properties = properties;
      })
    );
  }

  public prepareRequestProperty(ParentId): Observable<any> {
    const queryColumn = new Array<QueryColumn>();
    queryColumn.push(
      {
        OPath: 'Designation',
        Name: 'Designation',
      },
      {
        OPath: 'Type',
        Name: 'Type',
      },
      {
        OPath: 'TextValue',
        Name: 'TextValue',
      },
      {
        OPath: 'Id',
        Name: 'Id',
      }
    );
    // const observable = new Observable(observer => {
    const query = this.coreDataService.createSimpleQuery(
      '',
      'Property',
      'ParentId=' + "'" + ParentId + "'" + '',
      queryColumn
    );

    // observer.next(this.propertyData);
    // }));
    // });
    return this.coreDataService.executeReadObjectsQuery(query).pipe(
      tap((data) => {
        if (!this.propertyData) this.propertyData = [];
        const properties: PropertyModel[] = <PropertyModel[]>data;
        if (properties?.length) {
          properties.forEach((property) => {
            this.propertyData.push(new PropertyModel(property));
          });
        }
        return this.propertyData;
      })
    );
  }

  public prepareRequestPickListItem(picklistItem: string): Observable<any> {
    const observable$ = new Observable((observer) => {
      const query: ReadPicklistItemsModel = new ReadPicklistItemsModel();
      query.Name = picklistItem;
      this.coreDataService.executeReadPicklistsItemsQuery(query).subscribe((data: ListDataSource) => {
        this.picklistItem = new ListDataSource(data);
        observer.next(this.picklistItem);
      });
    });
    return observable$;
  }

  public queryVisibleColumns(objectType: string, id: string, properties): Observable<any> {
    const queryColumn = new Array<QueryColumn>();
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        const property = properties[key];
        queryColumn.push({
          Name: property.name,
          OPath: property.opath,
        });
      }
    }
    const query = this.coreDataService.createSimpleQuery('', objectType, `Id='${id}'`, queryColumn);
    return queryColumn.length > 0 ? this.coreDataService.executeReadObjectsQuery(query) : of({});
  }
}
